import { useSelector } from "react-redux";
import { Typography } from "@mui/material"

import { PrincipalLayouts } from "../../layouts"
import {GetOpportunitiesAdmin} from "../components/opportunities"

export const Opportunities = () => {

  const { role } = useSelector(state => state.auth)

  return (
    <PrincipalLayouts>
      {
        role !== 'LP'
          ?
          <GetOpportunitiesAdmin/>
          :
          <Typography variant='h4' color='primary'>Opportunities LP</Typography>
      }
    </PrincipalLayouts>
  )
}
